import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "../../../";

import { Classes, IMPDSelectableItem, MPDMultiLineText } from "src/mpd-library";

import { HTMLDivProps, Text } from "@blueprintjs/core";

import { convertUTCToDate } from "src/actions";

import "./styles.css";

export interface IAlertsListItemProps extends IMPDSelectableItem, HTMLDivProps {
  loading?: boolean;
  data: any;
}

export class AlertsListItem extends React.Component<IAlertsListItemProps> {
  public static defaultProps: IAlertsListItemProps = {
    data: {}
  };

  public render() {
    const { className, data, loading, onItemClick } = this.props;
    const { description, title, type, date } = data;
    const classes = classNames(myClasses.ALERTS_LIST_ITEM, className);

    return (
      <div className={classes} onClick={onItemClick}>
        <div className={myClasses.ALERTS_LIST_ITEM_CONTAINER}>
          <div
            className={classNames(
              myClasses.ALERTS_LIST_ITEM_INNER_CONTAINER,
              className,
              Classes.severitiesClass(type),
              loading && Classes.LOADING
            )}
          >
            <hr className={classNames(Classes.severitiesClass(type))} />
            <div
              className={classNames(
                myClasses.ALERTS_LIST_ITEM_HEADER,
                Classes.severitiesClass(type),
                loading && Classes.LOADING
              )}
            >
              <div className={myClasses.ALERTS_LIST_ITEM_HEADER_TOP}>
                <h6
                  className={classNames(
                    myClasses.ALERTS_LIST_ITEM_HEADER_TYPE,
                    Classes.severitiesClass(type),
                    loading && Classes.LOADING,
                    loading && "mpd-list-loader-animated"
                  )}
                >
                  {!loading && type}
                </h6>
                <Text
                  className={classNames(
                    myClasses.ALERTS_LIST_ITEM_HEADER_DATE,
                    Classes.severitiesClass(type),
                    loading && Classes.LOADING,
                    loading && "mpd-list-loader-animated"
                  )}
                >
                  {!loading && convertUTCToDate(date)}
                </Text>
              </div>
              <Text
                className={classNames(
                  myClasses.ALERTS_LIST_ITEM_HEADER_TITLE,
                  Classes.severitiesClass(type),
                  loading && Classes.LOADING,
                  loading && "mpd-list-loader-animated"
                )}
              >
                {!loading && title}
              </Text>
            </div>
            <MPDMultiLineText
              text={!loading && description}
              charLimit={80}
              className={classNames(
                myClasses.ALERTS_LIST_ITEM_DESCRIPTION,
                className,
                loading && Classes.LOADING,
                loading && "mpd-list-loader-animated"
              )}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/list-items/alerts-list-item/alerts-list-item.tsx